import React, { useState } from "react"
import { useRecoilState } from "recoil"
import { collapsedState } from "../../utils/recoil-atoms"
import { Link } from "gatsby"
import { redirectToStore } from "../../utils/redirect"
import logo from "../../assets/images/logo-bluemail.svg"
import { trackCustomEvent } from "gatsby-plugin-google-analytics"
import { isMobile } from "react-device-detect"
import android from '../../assets/images/android.webp'
import unifiedNav from '../../assets/images/nav/unified-inbox-nav.svg'
import shareNav from '../../assets/images/nav/share-email-nav.svg'
import instantNav from '../../assets/images/nav/instant-push-nav.svg'
import webmailNav from '../../assets/images/nav/webmail-nav.svg'
import getStafNav from '../../assets/images/nav/get-staf-done-nav.svg'
import integratedNav from '../../assets/images/nav/integrated-calendar-nav.svg'
import blueChatNav from '../../assets/images/nav/blue-chat-nav.svg'
import clustersNav from '../../assets/images/nav/clusters-nav.svg'
import securityNav from '../../assets/images/nav/security-center-nav.svg'
import blueWorkNav from '../../assets/images/nav/blue-mail-work-nav.svg'
import seeAllNav from '../../assets/images/nav/see-all-nav.svg'
import gemAi from '../../assets/images/nav/gemAi.svg'


const Navbar = () => {
  const [collapsed, setCollapsed] = useRecoilState(collapsedState)
  const [open, setOpen] = useState(false)
  const [dropClass, setDropClass] = useState("dropdown-menu")
  const [arrowDirection, setArrowDirection] = useState("arrow-hover-up")
  const [isTouch, setIsTouch] = useState("")

  const toggleNavbar = () => {
    setCollapsed(!collapsed)
  }

  React.useEffect(() => {
    let elementId = document.getElementById("navbar")
    document.addEventListener(
      "scroll",
      () => {
        if (window.scrollY > 170) {
          elementId.classList.add("is-sticky")
        } else {
          elementId.classList.remove("is-sticky")
        }
      },
      { passive: true }
    )
    window.scrollTo(0, 0)
    if (typeof window !== `undefined`) {
      setIsTouch("ontouchstart" in window || navigator.msMaxTouchPoints > 0)
    }

    if (window.location.pathname === "/features-functions/") {
      setDropClass("dropdown-menu drop-down-visibility")
      setArrowDirection("")
    }
  }, [])

  const classOne = collapsed
    ? "collapse navbar-collapse"
    : "collapse navbar-collapse show"
  const classTwo = collapsed
    ? "navbar-toggler navbar-toggler-right collapsed"
    : "navbar-toggler navbar-toggler-right"

  let isFirefox
  let isSafari
  if (typeof window !== "undefined") {
    isFirefox = typeof InstallTrigger !== "undefined"
    isSafari =
      /constructor/i.test(window.HTMLElement) ||
      (function (p) {
        return p.toString() === "[object SafariRemoteNotification]"
      })(
        !window["safari"] ||
          (typeof safari !== "undefined" && window["safari"].pushNotification)
      )
  }

  return (
    <React.Fragment>
      <div
        id="navbar"
        className={collapsed ? "navbar-area" : "collapsed-navbar-area"}
      >
        <div className="tarn-nav">
          <div className="container">
            <nav className="navbar navbar-expand-lg navbar-light">
              <Link
                to="/"
                onClick={() => setCollapsed(true)}
                className="navbar-brand"
              >
                <img src={logo} alt="logo" />
              </Link>
              <div className="d-flex">
              {(isMobile || isSafari) && (
                <div className="option-item download-top-right mr-2">
                  <a
                    href="#"
                    activeClassName="active"
                    onClick={e => {
                      e.preventDefault()
                      redirectToStore(e)
                      trackCustomEvent({
                        category: "download_now_clicked",
                        action: "download_now_clicked",
                      })
                    }}
                    className={"default-btn download-nav"}
                  >
                    Download <span></span>
                  </a>
                </div>
              )}
              <button
                onClick={toggleNavbar}
                className={classTwo}
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="icon-bar top-bar"></span>
                <span className="icon-bar middle-bar"></span>
                <span className="icon-bar bottom-bar"></span>
              </button>
              </div>
              

              <div className={classOne} id="navbarSupportedContent">
                <ul className="navbar-nav">
                  <li className={"nav-item " + arrowDirection}>
                    <Link to="/" activeClassName="active" className="nav-link">
                      Home
                    </Link>
                  </li>

                  {isTouch ? (
                    <li
                      className={
                        window.location.pathname === "/features-functions/"
                          ? "nav-item " + arrowDirection
                          : "nav-item-features "
                      }
                    >
                      <Link
                        to="/features-functions/"
                        activeClassName="active"
                        className={"nav-link-features"}
                        onClick={() => setOpen(!open)}
                      >
                        Features
                        {window.location.pathname === "/features-functions/" ? (
                          <i
                            className={
                              open ? "bx-chevron-up" : "bx-chevron-down"
                            }
                          ></i>
                        ) : (
                          <i className="bx-chevron-down"></i>
                        )}
                      </Link>

                      <ul
                        className={
                          dropClass.includes("visibility") && open
                            ? dropClass + " open"
                            : dropClass
                        }
                      >
                        <div className="container-fluid" style={{margin: "auto"}}>
                          <div className="row text-left">
                            <div className="col pb-1">
                              <li className="nav-item">
                                <Link
                                  to="/features-functions/unified-inbox/"
                                  activeClassName="active"
                                  onClick={() => setCollapsed(true)}
                                  className="nav-link"
                                >
                                  <div className="d-flex align-items-center">
                                    <div>
                                      <img style={{display: "inline-block", width: "50px", minWidth: "50px"}} src={unifiedNav} alt="Unified Inbox" />
                                    </div>
                                    <div style={{marginLeft:"7px", fontSize: "16px", fontWeight: "600", lineHeight: "18px"}}>
                                      Unified Inbox <br />
                                      <span style={{fontSize: "14px", fontWeight: "400", lineHeight: "20px", color: "rgba(0, 0, 0, 0.3)"}}>All accounts in one view</span>
                                    </div>
                                  </div> 
                                </Link>
                              </li>
                            </div>
                            <div className="col pb-1">
                              <li className="nav-item">
                                <Link
                                  to="/features-functions/get-stuff-done/"
                                  activeClassName="active"
                                  onClick={() => setCollapsed(true)}
                                  className="nav-link"
                                >
                                  <div className="d-flex align-items-center">
                                    <div>
                                      <img style={{display: "inline-block", width: "50px", minWidth: "50px"}} src={getStafNav} alt="Get Stuff Done" />
                                    </div>
                                    <div style={{marginLeft:"7px", fontSize: "16px", fontWeight: "600", lineHeight: "18px"}}>
                                      Get Stuff Done <br />
                                      <span style={{fontSize: "14px", fontWeight: "400", lineHeight: "20px", color: "rgba(0, 0, 0, 0.3)"}}>A task board for your emails</span>
                                    </div>
                                  </div>  
                                </Link>
                              </li>
                            </div>
                            <div className="col pb-1">
                              <li className="nav-item">
                                <Link
                                  to="/features-functions/clusters/"
                                  activeClassName="active"
                                  onClick={() => setCollapsed(true)}
                                  className="nav-link"
                                >
                                   <div className="d-flex align-items-center">
                                    <div>
                                      <img style={{display: "inline-block", width: "50px", minWidth: "50px"}} src={clustersNav} alt="Clusters" />
                                    </div>
                                    <div style={{marginLeft:"7px", fontSize: "16px", fontWeight: "600", lineHeight: "18px"}}>
                                      Clusters <br />
                                      <span style={{fontSize: "14px", fontWeight: "400", lineHeight: "20px", color: "rgba(0, 0, 0, 0.3)"}}>Organize emails by sender & group</span>
                                    </div>
                                  </div>  
                                </Link>
                              </li>
                            </div>
                            <div className="col pb-1">
                              <li className="nav-item">
                                <Link
                                  to="/features-functions/share/"
                                  activeClassName="active"
                                  onClick={() => setCollapsed(true)}
                                  className="nav-link"
                                >
                                  <div className="d-flex align-items-center">
                                    <div>
                                      <img style={{display: "inline-block", width: "50px", minWidth: "50px"}} src={shareNav} alt="Share Mail" />
                                    </div>
                                    <div style={{marginLeft:"7px", fontSize: "16px", fontWeight: "600", lineHeight: "18px"}}>
                                      Share Mail <br />
                                      <span style={{fontSize: "14px", fontWeight: "400", lineHeight: "20px", color: "rgba(0, 0, 0, 0.3)"}}>With family and friends</span>
                                    </div>
                                  </div>  
                                </Link>
                              </li>
                            </div>
                          </div>
                          <div className="row text-left">
                            <div className="col pb-1">
                              <li className="nav-item">
                                <Link
                                  to="/calendar/"
                                  activeClassName="active"
                                  onClick={() => setCollapsed(true)}
                                  className="nav-link"
                                >
                                  <div className="d-flex align-items-center">
                                    <div>
                                      <img style={{display: "inline-block", width: "50px", minWidth: "50px"}} src={integratedNav} alt="Integrated Calendar" />
                                    </div>
                                    <div style={{marginLeft:"7px", fontSize: "16px", fontWeight: "600", lineHeight: "18px"}}>
                                      Integrated Calendar <br />
                                      <span style={{fontSize: "14px", fontWeight: "400", lineHeight: "20px", color: "rgba(0, 0, 0, 0.3)"}}>Plan events right within BlueMail</span>
                                    </div>
                                  </div> 
                                </Link>
                              </li>
                            </div>
                            <div className="col pb-1">
                              <li className="nav-item">
                                <Link
                                  to="/security/"
                                  activeClassName="active"
                                  onClick={() => setCollapsed(true)}
                                  className="nav-link"
                                >
                                  <div className="d-flex align-items-center">
                                    <div>
                                      <img style={{display: "inline-block", width: "50px", minWidth: "50px"}} src={securityNav} alt="Our safe and secure approach" />
                                    </div>
                                    <div style={{marginLeft:"7px", fontSize: "16px", fontWeight: "600", lineHeight: "18px"}}>
                                      Security Center <br />
                                      <span style={{fontSize: "14px", fontWeight: "400", lineHeight: "20px", color: "rgba(0, 0, 0, 0.3)"}}>Our safe and secure approach</span>
                                    </div>
                                  </div> 
                                </Link>
                              </li>
                            </div>
                            <div className="col pb-1">
                              <li className="nav-item">
                                <Link
                                  to="/features-functions/instant-push/"
                                  activeClassName="active"
                                  onClick={() => setCollapsed(true)}
                                  className="nav-link"
                                >
                                  <div className="d-flex align-items-center">
                                    <div>
                                      <img style={{display: "inline-block", width: "50px", minWidth: "50px"}} src={instantNav} alt="Instant Push" />
                                    </div>
                                    <div style={{marginLeft:"7px", fontSize: "16px", fontWeight: "600", lineHeight: "18px"}}>
                                      Instant Push <br />
                                      <span style={{fontSize: "14px", fontWeight: "400", lineHeight: "20px", color: "rgba(0, 0, 0, 0.3)"}}>Receive emails directly and fast</span>
                                    </div>
                                  </div> 
                                </Link>
                              </li>
                            </div>
                            <div className="col pb-1">
                              <li className="nav-item">
                                <Link
                                  to="/bluechat/"
                                  activeClassName="active"
                                  onClick={() => setCollapsed(true)}
                                  className="nav-link"
                                >
                                  <div className="d-flex align-items-center">
                                    <div>
                                      <img style={{display: "inline-block", width: "50px", minWidth: "50px"}} src={blueChatNav} alt="BlueChat" />
                                    </div>
                                    <div style={{marginLeft:"7px", fontSize: "16px", fontWeight: "600", lineHeight: "18px"}}>
                                      BlueChat <br />
                                      <span style={{fontSize: "14px", fontWeight: "400", lineHeight: "20px", color: "rgba(0, 0, 0, 0.3)"}}>Our complimentary chat application</span>
                                    </div>
                                  </div>  
                                </Link>
                              </li>
                            </div>                            
                          </div>
                          <div className="row text-left">
                           <div className="col pb-1">
                              <li className="nav-item">
                                <Link
                                  to="/features-functions/generative-email/"
                                  activeClassName="active"
                                  onClick={() => setCollapsed(true)}
                                  className="nav-link"
                                >
                                  <div className="d-flex align-items-center">
                                    <div>
                                      <img style={{display: "inline-block", width: "50px", minWidth: "50px"}} src={gemAi} alt="Generative Email" />
                                    </div>
                                    <div style={{marginLeft:"7px", fontSize: "16px", fontWeight: "600", lineHeight: "18px"}}>
                                      Gem AI <br />
                                      <span style={{fontSize: "14px", fontWeight: "400", lineHeight: "20px", color: "rgba(0, 0, 0, 0.3)"}}>Generative Email</span>
                                    </div>
                                  </div>  
                                </Link>
                              </li>
                            </div>
                          </div>
                          <div className="row text-left">
                            <div className="col pb-1">
                              <li className="nav-item" style={{marginTop: "7px"}}>
                              <Link
                                to="/features-functions/"
                                activeClassName="active"
                                onClick={() => setCollapsed(true)}
                                className="nav-link"
                              >
                                <span style={{fontSize: "16px", fontWeight: "600" ,background: "#1F6BF1", color: "#fff", borderRadius: "34px", padding: "5px 40px 7px", lineHeight: "40px", textTransform: "uppercase"}}> See Feature Highlights<img style={{display: "inline-block", verticalAlign: "initial", marginLeft: "5px"}} src={seeAllNav} alt="see all" /> </span>
                              </Link>
                              </li>
                            </div>
                          </div>
                        </div>
                      </ul>
                    </li>
                  ) : (
                    <li className={"nav-item " + arrowDirection}>
                      <Link
                        to="/features-functions/"
                        activeClassName="active"
                        className={"nav-link"}
                        onClick={() => setOpen(!open)}
                      >
                        Features{" "}
                        <i
                          className={open ? "bx-chevron-up" : "bx-chevron-down"}
                        ></i>
                      </Link>

                      <ul
                        className={
                          dropClass.includes("visibility") && open
                            ? dropClass + " open"
                            : dropClass
                        }
                      >
                      <div className="container-fluid" style={{margin: "auto"}}>
                          <div className="row text-left">
                            <div className="col pb-1">
                              <li className="nav-item">
                                <Link
                                  to="/features-functions/unified-inbox/"
                                  activeClassName="active"
                                  onClick={() => setCollapsed(true)}
                                  className="nav-link"
                                >
                                  <div className="d-flex align-items-center">
                                    <div>
                                      <img style={{display: "inline-block", width: "50px", minWidth: "50px"}} src={unifiedNav} alt="Unified Inbox" /> 
                                    </div>
                                    <div style={{marginLeft:"7px", fontSize: "16px", fontWeight: "600", lineHeight: "18px"}}>
                                      Unified Inbox <br />
                                      <span style={{fontSize: "14px", fontWeight: "400", lineHeight: "20px", color: "rgba(0, 0, 0, 0.3)"}}>All accounts in one view</span>
                                    </div>
                                  </div>                                   
                                </Link>
                              </li>
                            </div>
                            <div className="col pb-1">
                              <li className="nav-item">
                                <Link
                                  to="/features-functions/get-stuff-done/"
                                  activeClassName="active"
                                  onClick={() => setCollapsed(true)}
                                  className="nav-link"
                                >
                                  <div className="d-flex align-items-center">
                                    <div>
                                      <img style={{display: "inline-block", width: "50px", minWidth: "50px"}} src={getStafNav} alt="Get Stuff Done" />
                                    </div>
                                    <div style={{marginLeft:"7px", fontSize: "16px", fontWeight: "600", lineHeight: "18px"}}>
                                      Get Stuff Done <br />
                                      <span style={{fontSize: "14px", fontWeight: "400", lineHeight: "20px", color: "rgba(0, 0, 0, 0.3)"}}>A task board for your emails</span>
                                    </div>
                                  </div>   
                                </Link>
                              </li>
                            </div>
                            <div className="col pb-1">
                              <li className="nav-item">
                                <Link
                                  to="/features-functions/clusters/"
                                  activeClassName="active"
                                  onClick={() => setCollapsed(true)}
                                  className="nav-link"
                                >
                                  <div className="d-flex align-items-center">
                                    <div>
                                      <img style={{display: "inline-block", width: "50px", minWidth: "50px"}} src={clustersNav} alt="Clusters" />
                                    </div>
                                    <div style={{marginLeft:"7px", fontSize: "16px", fontWeight: "600", lineHeight: "18px"}}>
                                      Clusters <br />
                                      <span style={{fontSize: "14px", fontWeight: "400", lineHeight: "20px", color: "rgba(0, 0, 0, 0.3)"}}>Organize emails by sender & group</span>
                                    </div>
                                  </div>   
                                </Link>
                              </li>
                            </div>
                            <div className="col pb-1">
                              <li className="nav-item">
                                <Link
                                  to="/features-functions/share/"
                                  activeClassName="active"
                                  onClick={() => setCollapsed(true)}
                                  className="nav-link"
                                >
                                  <div className="d-flex align-items-center">
                                    <div>
                                      <img style={{display: "inline-block", width: "50px", minWidth: "50px"}} src={shareNav} alt="Share Mail" />
                                    </div>
                                    <div style={{marginLeft:"7px", fontSize: "16px", fontWeight: "600", lineHeight: "18px"}}>
                                      Share Mail <br />
                                      <span style={{fontSize: "14px", fontWeight: "400", lineHeight: "20px", color: "rgba(0, 0, 0, 0.3)"}}>With family and friends</span>
                                    </div>
                                  </div>  
                                </Link>
                              </li>
                            </div>
                            <div className="col pb-1">
                              <li className="nav-item">
                                <Link
                                  to="/calendar/"
                                  activeClassName="active"
                                  onClick={() => setCollapsed(true)}
                                  className="nav-link"
                                >
                                  <div className="d-flex align-items-center">
                                    <div>
                                      <img style={{display: "inline-block", width: "50px", minWidth: "50px"}} src={integratedNav} alt="Integrated Calendar" />
                                    </div>
                                    <div style={{marginLeft:"7px", fontSize: "16px", fontWeight: "600", lineHeight: "18px"}}>
                                      Integrated Calendar <br />
                                      <span style={{fontSize: "14px", fontWeight: "400", lineHeight: "20px", color: "rgba(0, 0, 0, 0.3)"}}>Plan events right within BlueMail</span>
                                    </div>
                                  </div>  
                                </Link>
                              </li>
                            </div>
                          </div>
                          <div className="row text-left">                            
                            <div className="col pb-1">
                              <li className="nav-item">
                              <Link
                                to="/security/"
                                activeClassName="active"
                                onClick={() => setCollapsed(true)}
                                className="nav-link"
                              >
                                <div className="d-flex align-items-center">
                                    <div>
                                      <img style={{display: "inline-block", width: "50px", minWidth: "50px"}} src={securityNav} alt="Security Center" />
                                    </div>
                                    <div style={{marginLeft:"7px", fontSize: "16px", fontWeight: "600", lineHeight: "18px"}}>
                                      Security Center <br />
                                      <span style={{fontSize: "14px", fontWeight: "400", lineHeight: "20px", color: "rgba(0, 0, 0, 0.3)"}}>Our safe and secure approach</span>
                                    </div>
                                </div>  
                              </Link>
                              </li>
                            </div>
                            <div className="col pb-1">
                              <li className="nav-item">
                              <Link
                                to="/features-functions/instant-push/"
                                activeClassName="active"
                                onClick={() => setCollapsed(true)}
                                className="nav-link"
                              >
                                <div className="d-flex align-items-center">
                                    <div>
                                      <img style={{display: "inline-block", width: "50px", minWidth: "50px"}} src={instantNav} alt="Instant Push" />
                                    </div>
                                    <div style={{marginLeft:"7px", fontSize: "16px", fontWeight: "600", lineHeight: "18px"}}>
                                      Instant Push <br />
                                      <span style={{fontSize: "14px", fontWeight: "400", lineHeight: "20px", color: "rgba(0, 0, 0, 0.3)"}}>Receive emails directly and fast</span>
                                    </div>
                                </div>  
                              </Link>
                              </li>
                            </div>
                            <div className="col pb-1">
                              <li className="nav-item">
                              <Link
                                to="/bluechat/"
                                activeClassName="active"
                                onClick={() => setCollapsed(true)}
                                className="nav-link"
                              >
                                <div className="d-flex align-items-center">
                                    <div>
                                      <img style={{display: "inline-block", width: "50px", minWidth: "50px"}} src={blueChatNav} alt="BlueChat" />
                                    </div>
                                    <div style={{marginLeft:"7px", fontSize: "16px", fontWeight: "600", lineHeight: "18px"}}>
                                      BlueChat <br />
                                      <span style={{fontSize: "14px", fontWeight: "400", lineHeight: "20px", color: "rgba(0, 0, 0, 0.3)"}}>Our complimentary chat application</span>
                                    </div>
                                </div>  
                              </Link>
                              </li>
                            </div> 
                            <div className="col pb-1">
                              <li className="nav-item">
                              <Link
                                to="/features-functions/generative-email/"
                                activeClassName="active"
                                onClick={() => setCollapsed(true)}
                                className="nav-link"
                              >
                                <div className="d-flex align-items-center">
                                    <div>
                                      <img style={{display: "inline-block", width: "50px", minWidth: "50px"}} src={gemAi} alt="Generative Email" />
                                    </div>
                                    <div style={{marginLeft:"7px", fontSize: "16px", fontWeight: "600", lineHeight: "18px"}}>
                                      Gem AI <br />
                                      <span style={{fontSize: "14px", fontWeight: "400", lineHeight: "20px", color: "rgba(0, 0, 0, 0.3)"}}>Generative Email</span>
                                    </div>
                                </div>  
                              </Link>
                              </li>
                            </div>  
                            <div className="col pb-1">
                              {!isMobile && !isSafari && !isFirefox && (
                              <li className="nav-item">
                                <Link
                                  to="https://web.bluemail.me"
                                  activeClassName="active"
                                  onClick={() => setCollapsed(true)}
                                  className="nav-link"
                                >
                                  <div className="d-flex align-items-center">
                                    <div>
                                      <img style={{display: "inline-block", width: "50px", minWidth: "50px"}} src={webmailNav} alt="Webmail" />
                                    </div>
                                    <div style={{marginLeft:"7px", fontSize: "16px", fontWeight: "600", lineHeight: "18px"}}>
                                      Webmail <br />
                                      <span style={{fontSize: "14px", fontWeight: "400", lineHeight: "20px", color: "rgba(0, 0, 0, 0.3)"}}>Sign in on any browser</span>
                                    </div>
                                  </div>
                                </Link>
                              </li>
                              )}
                            </div>                           
                          </div>
                          
                          <div className="row text-left">
                            <div className="col pb-1">
                              <li className="nav-item">
                              <Link
                                to="/features-functions/"
                                activeClassName="active"
                                onClick={() => setCollapsed(true)}
                                className="nav-link"
                              >
                                <span style={{fontSize: "16px", fontWeight: "600" ,background: "#1F6BF1", color: "#fff", borderRadius: "34px", padding: "5px 40px 7px", lineHeight: "40px", textTransform: "uppercase"}}> See all Features <img style={{display: "inline-block", verticalAlign: "initial", marginLeft: "5px"}} src={seeAllNav} alt="see all" /> </span>
                              </Link>
                              </li>
                            </div>
                          </div>
                        </div>
                      </ul>
                    </li>
                  )}

                  <li className="nav-item">
                    <Link
                      to="/blog/"
                      activeClassName="active"
                      className="nav-link"
                    >
                      Blog
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/pricing/"
                      activeClassName="active"
                      className="nav-link"
                    >
                      Pricing
                    </Link>
                  </li>
                </ul>
                {typeof window !== "undefined" && (
                  <div className="others-option d-block text-center align-items-center">
                    {/* {!isMobile && !isSafari && <div className="option-item">
                                        <a  
                                            href="#" 
                                            activeClassName="active"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                redirectToWeb(e); 
                                                trackCustomEvent({
                                                    category: "sign_in_clicked",
                                                    action: "sign_in_clicked",
                                                });
                                            }
                                        }
                                            className="default-btn"
                                        >
                                            Sign In <span></span>
                                        </a>
                                    </div>} */}
                    {!isMobile && !isSafari && (
                      <div className="option-item">
                        <a
                          href="#"
                          activeClassName="active"
                          onClick={e => {
                            e.preventDefault()
                            redirectToStore(e)
                            trackCustomEvent({
                              category: "download_now_clicked",
                              action: "download_now_clicked",
                            })
                          }}
                          className={"default-btn-white"}
                        >
                          Download Now <span></span>
                        </a>
                      </div>
                    )}
                    {(isMobile || isSafari) && (
                      <div className="option-item">
                        <a
                          href="#"
                          activeClassName="active"
                          onClick={e => {
                            e.preventDefault()
                            redirectToStore(e)
                            trackCustomEvent({
                              category: "download_now_clicked",
                              action: "download_now_clicked",
                            })
                          }}
                          className={"default-btn"}
                        >
                          Download Now <span></span>
                        </a>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </nav>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Navbar
